<template>
	<footer>
		<div class="container doc-page">
			<div class="row">
				<div class="col q-mt-xl">
					<img 
						id="site-logo__footer"
						:src="require(`@/assets/imgs/common/logo-white.png`)">
				</div>
				<div class="col">
					<h4>
						AONE LOGISTICS PTY LTD<br>
						(에이원택배)
					</h4>
					<dl>
							<dt><strong>NSW</strong></dt>
							<dd class="q-mb-md">K10 / 161 ARTHUR ST HOMEBUSH WEST NSW 2140</dd>
							<dt><strong>KOREA</strong></dt>
							<dd>서울시 강서구 양천로 401, B동 816호 (한강자이타워)</dd>
					</dl>

					<h4>
							CUSTOMER SERVICE
					</h4>
					<dl>
						<dt><strong>NSW</strong></dt>
						<dd class="q-mb-md">
							MON TO FRI 09:00 – 17:00 (AEST)<br />
							PHONE : 02-8515-7070<br />
							E-MAIL : <a href="mailto:cs@aonelogistics.com.au">cs@aonelogistics.com.au</a><br />
							카카오톡 : aonesyd
						</dd>
						<dt><strong>KOREA</strong></dt>
						<dd>
							MON TO FRI 09:00 – 18:00(KST)<br />
							PHONE : 010-9879-6488<br />
							E-MAIL : <a href="mailto:excs@aonelogistics.com.au">excs@aonelogistics.com.au</a><br />
							카카오톡 : excs_aone<br />
						</dd>
					</dl>
				</div>
				<div class="col menu">
					<h4>
							MENU
					</h4>
					<dl>
						<dt><strong>배송조회.신청</strong></dt>
						<dd>KOR→SYD | SYD→KOR</dd>
						<dt class="q-mt-md"><strong>운임정보</strong></dt>
						<dd>KOR→SYD | SYD→KOR</dd>
						<dt class="q-mt-md"><strong>서비스</strong></dt>
						<dd>항공 | 해상</dd>
						<dd>전자상거래 컨설팅</dd>
						<dd>풀필먼트 서비스</dd>
						<dd>상업화물 서비스 | 창고보관</dd>
						<dt class="q-mt-md"><strong>공지사항</strong></dt>
						<dt class="q-mt-md"><strong>회사소개</strong></dt>
					</dl>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>


export default {
	name: "FooterComponent",
	data() {
		return {
			description: {
				title: "Footer"
			}
		}
	},
	method:{},
	components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
